import { ReactNode } from 'react'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { FormField } from './FormField'

export interface SelectOption {
  value: string
  label: string
  icon?: ReactNode
}

interface SelectFieldProps {
  /** The name/id of the select field */
  name: string
  /** The label text for the field */
  label: string
  /** Whether the field is required */
  required?: boolean
  /** Array of options to display */
  options: SelectOption[]
  /** Current selected value */
  value: string
  /** Callback when value changes */
  onValueChange: (value: string) => void
  /** Error message to display */
  error?: string
  /** Whether the field is disabled */
  disabled?: boolean
  /** Placeholder text */
  placeholder?: string
  /** Help text to display below the field */
  helpText?: string
  /** Additional CSS classes */
  className?: string
}

export function SelectField({
  name,
  label,
  required = false,
  options,
  value,
  onValueChange,
  error,
  disabled = false,
  placeholder,
  helpText,
  className = '',
}: SelectFieldProps) {
  return (
    <FormField
      label={label}
      required={required}
      error={error}
      helpText={helpText}
      htmlFor={name}
      className={className}
    >
      <Select value={value} onValueChange={onValueChange} disabled={disabled}>
        <SelectTrigger id={name}>
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          {options.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              <div className="flex items-center gap-2">
                {option.icon && option.icon}
                <span>{option.label}</span>
              </div>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </FormField>
  )
}
